var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 7.34358 1 4.51411 2.75705 2.75705C4.51411 1 7.34232 1 13 1C18.6564 1 21.4859 1 23.2429 2.75705C25 4.51411 25 7.34232 25 13C25 18.6564 25 21.4859 23.2429 23.2429C21.4859 25 18.6577 25 13 25C7.34358 25 4.51411 25 2.75705 23.2429C1 21.4859 1 18.6577 1 13Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9581 6.05273H19.9455M18.6848 13.0001C18.6848 14.5076 18.086 15.9535 17.02 17.0194C15.954 18.0854 14.5082 18.6843 13.0006 18.6843C11.4931 18.6843 10.0473 18.0854 8.98127 17.0194C7.91528 15.9535 7.31641 14.5076 7.31641 13.0001C7.31641 11.4926 7.91528 10.0468 8.98127 8.98076C10.0473 7.91476 11.4931 7.31589 13.0006 7.31589C14.5082 7.31589 15.954 7.91476 17.02 8.98076C18.086 10.0468 18.6848 11.4926 18.6848 13.0001Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.466b0c6a96511d07786e9f588cd05fef.svg";
export { ForwardRef as ReactComponent };